import creatorSdk from '@src/services/creator-sdk';
import { DomainPublic } from '@creator/sdk/modules/domain/domain.model';

export async function loadPublicData(id: string): Promise<DomainPublic | undefined> {
    return creatorSdk.domainModule.getPublicData(id);
}
